import Model from './Model'

export default class Service extends Model {
    resource() {
        return 'admin/services'
    }
}
